import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=717d35bf&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=717d35bf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717d35bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('717d35bf')) {
      api.createRecord('717d35bf', component.options)
    } else {
      api.reload('717d35bf', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=717d35bf&scoped=true", function () {
      api.rerender('717d35bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/order/detail.vue"
export default component.exports